

import TiwiMixin from '../../mixins/TiwiMixin';
// import { defineAsyncComponent } from 'vue';
import { SVG } from '@svgdotjs/svg.js'
import { Canvg } from "canvg";

import { ColorPicker } from "vue3-colorpicker";



import Splide from '@splidejs/splide';

export default {
  mixins: [TiwiMixin],
  components: {
    ColorPicker
  },
  props: {
    onSubmit: {
      type: Function,
    },
    onCancel: {
      type: Function,
    },

  },
  data() {
    return {
      editor_config: null,
      user_config: null,


      features:{
        background: null,
        body: null,
        shadow: null,
        shirt: null,
        face: null,
        beard: null,
        hair: null,
        accessories: null,
      },

      colors:{
        background: null,
        body: null,
        hair: null,
        shirt: null,
      }


    }
  },
  mounted: function () {
    this.getEditorConfig();

    // NO REACTIVE
    this.draw = SVG().addTo('#svg_canvas').size(300, 300)
    

    this.groups = {};
    
    this.groups.background = this.draw.group();
    this.groups.body = this.draw.group();
    this.groups.shadow = this.draw.group();
    this.groups.shirt = this.draw.group();
    this.groups.face = this.draw.group();
    
   
    this.groups.beard = this.draw.group();
    this.groups.hair = this.draw.group();
    this.groups.accessories = this.draw.group();

    
  },
  methods: {
    getEditorConfig: function(){
      var self = this;
      
      self.setLoading(true);
      this.api.get('avatar/getConfig')
      .then((response) => {

        self.setLoading(false);

        if (response.data.success) {
          self.editor_config = response.data.editor_config;
          self.user_config = response.data.user_config;

          
          if( self.editor_config.features.static.length > 0){

            // SFONDO 
            var background = self.editor_config.features.static.find( ( item ) => item.basename == 'background.svg');
            
            if( background )
              self.setFeature('background', background );
              

            // CORPO 
            var body = self.editor_config.features.static.find( ( item ) => item.basename == 'body.svg');
            if( body )
              self.setFeature('body', body );

            // OMBRA 
            var shadow = self.editor_config.features.static.find( ( item ) => item.basename == 'shadow.svg');
            if( shadow )
              self.setFeature('shadow', shadow );

            // MAGLIA 
            var shirt = self.editor_config.features.static.find( ( item ) => item.basename == 'shirt.svg');
            if( shirt )
              self.setFeature('shirt', shirt );

              
              console.log( background, body, shadow, shirt );

           
          }

          /*
          // CORPO
          if( self.editor_config.features.misc.length > 0){
            //self.setFeature('body', self.editor_config.features.body[0] );
          }

          // OMBRA
          if( self.editor_config.features.misc.length > 0){
            //self.setFeature('shadow', self.editor_config.features.shadow[0] );
          }

          // MAGLIETTA
          if( self.editor_config.features.shirt.length > 0){
            // var rnd_idx = self.getRandomInt( self.editor_config.features.shirt.length );
            self.setFeature('shirt', self.editor_config.features.shirt[0] );
          }
          */





          if( !response.data.user_config ){
            self.generateRandomAvatar();
          }
          else{

            // SFONDO (colore)
            if( self.user_config?.colors?.background){  
              self.setColor('background', self.user_config.colors.background );
            }

            // CORPO  (colore)
            if( self.user_config?.colors?.body){  
              self.setColor('body', self.user_config.colors.body );
            }
          
            // MAGLIETTA (colore)

            if( self.user_config?.colors?.shirt){  
              self.setColor('shirt', self.user_config.colors.shirt );
            }
          

            // FACCIA
            if( self.user_config?.features?.face){  

                var face_feature = this.editor_config.features.face.find( ( item ) => item.url == self.user_config?.features?.face );
                if( face_feature )
                  self.setFeature('face', face_feature );
              
            }
          

            // CAPELLI E BARBA

            if( self.user_config?.features?.hair){  

              var hair_feature = this.editor_config.features.hair.find( ( item ) => item.url == self.user_config?.features?.hair );
              if( hair_feature )    
                self.setFeature('hair', hair_feature );
              
            }

            if( self.user_config?.features?.beard){  

              var beard_feature = this.editor_config.features.beard.find( ( item ) => item.url == self.user_config?.features?.beard );
              if( beard_feature )    
                self.setFeature('beard', beard_feature );

            }

            if( self.user_config?.colors?.hair){  
              self.setColor('hair', self.user_config.colors.hair );
              self.setColor('beard', self.user_config.colors.hair );
            }

          
            // ACCESSORI
            if( self.user_config?.features?.accessories){  

              var accessories_feature = this.editor_config.features.accessories.find( ( item ) => item.url == self.user_config?.features?.accessories );
              if( accessories_feature )    
                self.setFeature('accessories', accessories_feature );

            }

          }


            
          self.$nextTick( function(){
            
            new Splide( '.splide-color-background', { perPage: 3, perMove:1, pagination: false, breakpoints: { 640: { perPage: 2, } } } ).mount();
            new Splide( '.splide-feature-face', { perPage: 4, perMove:1, pagination: false, breakpoints: { 640: { perPage: 2, } } } ).mount();
            new Splide( '.splide-color-body', { perPage: 4, perMove:1, pagination: false, breakpoints: { 640: { perPage: 2, } } } ).mount();
            new Splide( '.splide-feature-hair', { perPage: 4, perMove:1, pagination: false, breakpoints: { 640: { perPage: 2, } } } ).mount();
            new Splide( '.splide-feature-beard', { perPage: 4, perMove:1, pagination: false, breakpoints: { 640: { perPage: 2, } } } ).mount();
            new Splide( '.splide-feature-accessories', { perPage: 4, perMove:1, pagination: false, breakpoints: { 640: { perPage: 2, } } } ).mount();
            //new Splide( '.splide-feature-shirt', { perPage: 4, perMove:1, pagination: false } ).mount();
            //new Splide( '.splide-color-hair', { perPage: 4, perMove:1, pagination: false } ).mount();
          });

        }
        else {
          self.toast.error(response.data.message);
        }
      })
      .catch((error) => {
        console.log(error);
        self.toast.error('Errore nella richiesta');
      })
      .finally(() => self.setLoading(false))
    },

    setFeature: function( type, payload){

      console.log( type, payload );

      this.features[type] = payload;
      this.groups[type].clear();

      if( payload ){
        var result = this.groups[type].svg(payload.content);

        var auto_color = !this.features[type] ? true : false;
        if( auto_color ){
          if( this.editor_config.colors[type] && ( this.editor_config.colors[type].length > 0) ){
            this.setColor(type, this.editor_config.colors[type][0] );
          }
        }
      }
      
      

     
    },

    setColor: function( type, color ){

      this.colors[type] = color;
      switch(type){
       
        default:
          this.groups[type].fill({ color: color})
          break;
      }
      
    },

    clickRandomAvatar: function(){
      if( confirm('Generando un nuovo avatar casuale la configurazione attuale verrà sovrascritta. Procedere?') )
        this.generateRandomAvatar();
    },

    generateRandomAvatar: function(){
        

        if( this.editor_config.colors.background.length > 0){ 
          var rnd_idx = this.getRandomInt( this.editor_config.colors.background.length );
          this.setColor('background', this.editor_config.colors.background[rnd_idx] );
        }


        this.setColor('shirt', this.getRandomColor() );


        if( this.editor_config.colors.body.length > 0){
          var rnd_idx = this.getRandomInt( this.editor_config.colors.body.length );
          this.setColor('body', this.editor_config.colors.body[rnd_idx] );
        }


        if( this.editor_config.features.face.length > 0){
            
          var rnd_idx = this.getRandomInt( this.editor_config.features.face.length );
          this.setFeature('face', this.editor_config.features.face[rnd_idx] );
        
        } 


        if( this.editor_config.features.hair.length > 0){


          var features_hair = [];
          switch( this.user.meta.pronouns ){
            case 'm':
              features_hair = this.editor_config.features.hair.filter( ( item ) => item.url.toLowerCase().includes('m.') );
              break ;
            case 'f':
              features_hair = this.editor_config.features.hair.filter( ( item ) => item.url.toLowerCase().includes('f.') );
              break ;
            

          }
          if( features_hair.length == 0 )
            features_hair = this.editor_config.features.hair;

          var rnd_idx = this.getRandomInt( features_hair.length );
          this.setFeature('hair', features_hair[rnd_idx] );
        
        } 

        if( this.user.meta.pronouns == 'm' && this.editor_config.features.beard.length > 0){
            


          var rnd_flag = (this.getRandomInt( 12 ) % 3) == 0;
          
          if( rnd_flag ){
            var rnd_idx = this.getRandomInt( this.editor_config.features.beard.length );
            this.setFeature('beard', this.editor_config.features.beard[rnd_idx] );
          }
          else{
            this.setFeature('beard', null );
          }
          


        
        }

        if(this.editor_config.features.accessories.length > 0){
          if( this.user.meta.pronouns == 'f'){
            var rnd_idx = this.getRandomInt( this.editor_config.features.accessories.length );
            this.setFeature('accessories', this.editor_config.features.accessories[rnd_idx] );
          
          }

          if( this.user.meta.pronouns == 'm'){
            
            this.setFeature('accessories', null );
          
          }
        }
        
          

        
            
        var rnd_color = this.getRandomColor();

        this.setColor('hair', rnd_color );
        this.setColor('beard', rnd_color );

          


    },

    exportAvatar: function(){
      // .flatten()
      
      var svg_content = this.draw.svg()

      /*
      var canvas = document.createElement('canvas'); // Create a Canvas element.
      var ctx = canvas.getContext('2d'); // For Canvas returns 2D graphic.
      
      Canvg.fromString(ctx, svg_content); // Render SVG on Canvas.
      var base64 = canvas.toDataURL("image/png");
      */

      var user_config = {
        features:{
          body: this.features.body ? this.features.body.url : null,
          shirt: this.features.shirt ? this.features.shirt.url : null,
          face: this.features.face ? this.features.face.url : null,
          beard: this.features.beard ? this.features.beard.url : null,
          hair: this.features.hair ? this.features.hair.url : null,
          accessories: this.features.accessories ? this.features.accessories.url : null,
        },

        colors: this.colors,
      }

      if( this.onSubmit )
        //this.onSubmit( svg_content, base64 );
        this.onSubmit( svg_content, user_config );

       svg_content = null;
    }
  },
  computed: {
    
  }
}
